/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import moment from "moment";

export default function TableData() {


    const formCampaignRows = (data) => {
        let result = [];
        for (let dt of data) {
            result.push({
                template: dt?.template?.name,
                total: dt?.total_count,
                sent: dt?.sent_count,
                failed: dt?.failed_count,
                time: moment(dt.createdAt).format("DD-MM-YYYY HH:mm:ss")
            });

        }
        return result
    }

    return {
        formCampaignRows,
        campaignHeaders: [
            { Header: "Name", accessor: "template", align: "left" },
            { Header: "Total Count", accessor: "total", align: "center" },
            // { Header: "Sent Count", accessor: "sent", align: "center" },
            { Header: "Failed Count", accessor: "failed", align: "center" },
            { Header: "Time", accessor: "time", align: "center" }
        ],

    };
}
